import { ThemeProvider as WrappedThemeProvider, type ThemeProps } from '@rescuetablet/theme';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useSettingOrDefault } from './data/settings';

export function ThemeProvider({ theme, children }: PropsWithChildren<{ theme?: ThemeProps }>) {
  return <WrappedThemeProvider {...theme} children={children} />;
}

export function useUserTheme(): ThemeProps {
  const fontSize = useSettingOrDefault('fontSize');
  const colorScheme = useSettingOrDefault('colorScheme');
  const {
    i18n: { language },
  } = useTranslation();

  return { fontSize, colorScheme, language };
}
